import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  laws: {
    data: [],
    currentPage: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'law',
  initialState,
  reducers: {
    getlawSuccess: (state, action) => {
      state.laws = action.payload;
      state.loading = false;
    },
    startLoadinglaw: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getlaws = ({ accessToken, filters={} }) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoadinglaw());
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_API}/get-all-laws?startDate=${filters?.startDate}&&endDate=${filters?.endDate}`, { headers });
      dispatch(slice.actions.getlawSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};

